import { C } from "@/brand/tokens";

/**
 * FieldLabel — brass-numbered uppercase metadata label.
 *
 * Example rendered: "01.  FULL NAME"
 */
export function FieldLabel({ children, htmlFor, index, required }) {
  return (
    <label
      htmlFor={htmlFor}
      className="block font-inter text-[10.5px] uppercase font-semibold mb-3"
      style={{ color: C.accentMetal, letterSpacing: "0.26em" }}
    >
      {index && (
        <span
          className="mr-3 tabular-nums"
          style={{ color: C.accentMetal, fontWeight: 700 }}
        >
          {index}.
        </span>
      )}
      <span style={{ color: C.textOnLight }}>{children}</span>
      {required && (
        <span className="ml-2" style={{ color: C.accentMetal }}>
          ·
        </span>
      )}
    </label>
  );
}
